import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";
import { momentFullTime } from "../../../../../helpers/utils";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { ChangeOrderStatusAPI } from "../../../../Redux/orders";
import { useParams } from "react-router-dom";
import { BtnLoader } from "../../../../../Components/Components";
import {
  ORDER_FILTER_KEY,
  ORDER_REFETCH_KEY,
  ORDER_SCROLL_KEY,
} from "../../orderTypes";

const StatusChangeConfirmationModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<any>>;
  statusData: any;
  setIsStatusUpdateError: any;
  setStatusErrorData: any;
}> = ({
  visible,
  setIsModalVisible,
  statusData,
  setIsStatusUpdateError,
  setStatusErrorData,
}) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { changeOrderStatusLoading } = useAppSelector(
    (state: RootState) => state?.loading,
  );
  const onClose = () => {
    setIsModalVisible(null);
  };
  const handleSave = () => {
    const payload = {
      order_status: statusData?.status,
    };
    const handleSuccessStstus = () => {
      sessionStorage.removeItem(ORDER_SCROLL_KEY);
      sessionStorage.removeItem(ORDER_FILTER_KEY);
      sessionStorage.setItem(ORDER_REFETCH_KEY, "1");
      setIsModalVisible(null);
    };
    const handleErrorStatus = (data: any) => {
      setIsStatusUpdateError(data?.flag);
      console.log(data, "data?.datadata?.datadata?.data");
      setStatusErrorData(data?.data);
      setIsModalVisible(null);
    };
    dispatch(
      ChangeOrderStatusAPI(id, payload, handleSuccessStstus, handleErrorStatus),
    );
  };

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          {statusData?.title}
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-126"
            onClick={onClose}
            disabled={changeOrderStatusLoading}
          >
            CLOSE
          </button>
          <button
            type="button"
            className="btn btn-lg btn-primary min-w-126"
            onClick={handleSave}
            disabled={changeOrderStatusLoading}
          >
            {changeOrderStatusLoading ? <BtnLoader /> : "YES"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
          {statusData?.description}
        </p>
      </div>
    </Modal>
  );
};

export default StatusChangeConfirmationModal;
